/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SDDCStateEnum } from './sDDCStateEnum';


export interface SDDCData { 
    /**
     * Org Id
     */
    vcf_org_id: string;
    /**
     * Org Id
     */
    vmc_org_id: string;
    /**
     * AWS region in which SDDC resides
     */
    region: string;
    /**
     * SDDC UUID
     */
    sddc_id: string;
    /**
     * SDDC Name
     */
    sddc_name: string;
    sddc_state: SDDCStateEnum;
    /**
     * Time at which SDDC was created
     */
    created_at: Date;
    /**
     * User who created SDDC
     */
    created_by: string;
    /**
     * Number of ESX hosts in SDDC
     */
    host_count: number;
    /**
     * Various number of instance type
     */
    instance_type: { [key: string]: number; };
    /**
     * Time at which SDDC usage information was last sent
     */
    last_usage_sent_at: Date;
    /**
     * Time at which SDDC information was last updated
     */
    updated_at: Date;
}
export namespace SDDCData {
}


